module.exports = __webpack_public_path__ + "img/HPS013CP.b1170fd6.png";